import { CONFIG_PARAMS } from "../../system/SystemConfig";

export default class AddResult {
	public readonly data: any;

	constructor(data: any) {
		this.data = data;
	}

	getJackpot() {
		return this.data?.after_close?.joker_bonus ?? null;
	}

	/**
	 * @return {Object}
	 */
	getData() {
		return this.data;
	}

	getRoundId() {
		return this.data.round_id;
	}

	/**
	 * @return {boolean}
	 */
	isSilentClose(): boolean {
		return !!this.data.silent_close;
	}

	getGameSpecifics() {
		return this.data["result"]["gameSpecifics"];
	}

	getFSGameSpecifics() {
		return this.data["result"]["fsGameSpecifics"];
	}
	getFSTotalWin(){
		return this.data.after_close?.fs_total_win
	}

	/**
	 * @return {*}
	 */
	getSearching() {
		return this.data["result"]["gameSpecifics"]["searching"];
	}

	/**
	 * @return {*}
	 */
	getFreeSpinResults() {
		return this.data["result"]["freeSpinResults"];
	}

	/**
	 * @param {number} index
	 * @return {undefined|AddResult}
	 */
	getFreeSpinResult(index) {
		let data = this.data["result"]["freeSpinResults"][index];

		if (data) {
			return new AddResult(data);
		}

		return;
	}

	/**
	 * @return {number|undefined}
	 */
	getFreeSpinsNumber() {
		return this.data["result"]["freeSpinNumber"];
	}

	/**
	 * @param index
	 * @return {Object|undefined}
	 */
	getLineWin(index) {
		if (
			this.data["result"]["lineWins"] &&
			this.data["result"]["lineWins"][index]
		) {
			return this.data["result"]["lineWins"][index];
		}
	}

	/**
	 * @return {Array|undefined}
	 */
	getLineWins() {
		return this.data["result"]["lineWins"];
	}

	/**
	 * @return {Array|undefined}
	 */
	get lineWins() {
		return this.getLineWins();
	}

	/**
	 * @return {Array<number>}
	 */
	getReelMatrix() {
		return this.data["result"]["reelMatrix"];
	}

	/**
	 * @return {Array<number>}
	 */
	get reelMatrix() {
		return this.getReelMatrix();
	}

	/**
	 * @return {number|undefined}
	 */
	getWin() {
		return this.data["result"]["win"];
	}

	/**
	 * @return {number|undefined}
	 */
	get win() {
		return this.getWin();
	}

	getTotalWin(): number {
		return this.data["result"]["totalWin"];
	}

	/**
	 * @return {number|undefined}
	 */
	get totalWin() {
		return this.getTotalWin();
	}

	/**
	 * @return {number}
	 */
	getCredit() {
		return this.data["result"]["credit"];
	}

	/**
	 * @return {number}
	 */
	get credit() {
		return this.getCredit();
	}

	/**
	 * @return {boolean}
	 */
	isWin() {
		return !!(this.getLineWins() && this.getLineWins().length);
	}

	/**
	 * Returns lineWin by its index if exists or returns undefined
	 * @param {number} index
	 * @returns {Object|undefined}
	 */
	getLW(index) {
		return this.getLineWins() && this.getLineWins()[index];
	}

	/**
	 * Returns win value of line or undefined
	 * @param {number|undefined} line
	 */
	getLWWin(index) {
		return this.getLineWin(index) && this.getLineWins()[index]["win"];
	}

	getLWLine(index) {
		return this.getLineWin(index) && this.getLineWins()[index]["line"];
	}

	getLWPosition(index) {
		return this.getLineWin(index) && this.getLineWins()[index]["position"];
	}

	getLWSymbol(index) {
		return this.getLineWin(index) && this.getLineWins()[index]["symbol"];
	}

	getLWType(index) {
		return this.getLineWin(index) && this.getLineWins()[index]["type"];
	}

	getLWTotalWin(calcFunc?: Function): number {
		let win = 0;

		if (!this.getLineWins()) return 0;

		for (let lineWin of this.getLineWins()) {
			if (lineWin["win"]) {
				if (calcFunc) {
					win += calcFunc(lineWin["win"], lineWin);
				} else {
					win += lineWin["win"];
				}
			}
		}
		return win;
	}

	getBalance() {
		return this.data["balance"];
	}

	getCoin() {
		return this.data["result"]["coin"];
	}

	getBet() {
		return this.data["result"]["bet"];
	}

	getLinesCnt() {
		return this.data["result"]["lines_cnt"];
	}

	getBonus() {
		return this.data["bonus"];
	}

	getWindowMessage() {
		return this.data["window_messages"];
	}

	get gameSpecifics() {
		return this.getGameSpecifics();
	}

	initReplay(logic, behavior) {
		logic.gameSpecifics = this.getGameSpecifics();
		this.data["logic"] = logic;
		this.data.matrix = { reelMatrix: logic.failResult };
		this.data.behavior = behavior;
		this.data["matrix"]["position"] = this.data["result"].position;
	}
}
